import { LanguageSwitcher } from '@nx/i18n';

export interface SiteFooterProps {
  className?: string;
}

const year = new Date().getFullYear();

export function SiteFooter({ className }: SiteFooterProps) {
  return (
    <footer className={['bg-[#1A1A1A] text-[#FDEEB0]', className].filter(Boolean).join(' ')}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <h2
              className="text-2xl md:text-3xl text-[#FDEEB0] font-extrabold tracking-tight"
              style={{ fontFamily: 'var(--font-sans)' }}
            >
              N‑Excelsior
            </h2>
            <p className="mt-3 max-w-md text-sm text-[#FDEEB0]/80">
              Wellness, sport e cultura per aziende in Italia. Retreat, team building e
              programmi su misura.
            </p>
          </div>
          <div className="flex flex-col items-start gap-3 md:items-end">
            <LanguageSwitcher tone="dark" />
            <p className="text-xs text-[#FDEEB0]/60">
              © {year} N-Excelsior. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
